import {isLoggingOut} from '@albert-io/mandark/authentication/logoutState';

import {SESSION_EXPIRED_PATH} from 'lib/postLoginRedirect';

/**
 * Sends the browser to the expired-session page when the server marks the session inactive
 * (`x-authorization-inactive: true`), which happens after the user signs in somewhere else.
 * Skipped during a logout, so the eviction cannot replace the logout's own destination.
 */
export function redirectIfSessionReplaced(inactiveHeader: unknown): void {
  if (inactiveHeader === 'true' && !isLoggingOut()) {
    global.document.location = SESSION_EXPIRED_PATH;
  }
}
